import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Introduce from './views/Introduce.vue'
import Process from './views/Process.vue'
import Waiting from './views/Waiting.vue'
import Upgrade from './views/Upgrade.vue'
import Submitted from './views/Submitted.vue'
import Contact from './views/Contact.vue'
import Declare from './views/Declare.vue'
import Primary from './views/Primary.vue'
import Energy from './views/Energy.vue'
import TechnologyList from './views/TechnologyList.vue'
import UploadFile from './views/UploadFile.vue'
import Send from './views/Send.vue'
import Update from './views/Update.vue'
import Preview from './views/Preview.vue'
import WriteUpgrade from './views/WriteUpgrade.vue'

import { getUserInfo } from './utils/cache'
import store from './store'

Vue.use(Router)

export const leftRouters = [
  {
    path: '/introduce',
    name: 'introduce',
    component: Introduce,
    label: '协会介绍',
    leftMenu: 'introduce',
    icon: 'el-icon-document'
  },
  {
    path: '/process',
    name: 'process',
    component: Process,
    label: '申报流程',
    leftMenu: 'process',
    icon: 'el-icon-guide'
  },
  {
    path: '/declare',
    name: 'declare',
    label: '我的申报',
    component: Declare,
    leftMenu: 'declare',
    icon: 'el-icon-user',
    children: [
      {
        path: 'waiting',
        name: 'waiting',
        component: Waiting,
        label: '待提交项目',
        leftMenu: 'waiting',
        icon: 'el-icon-timer'
      },
      {
        path: 'upgrade',
        name: 'upgrade',
        component: Upgrade,
        label: '升级申报',
        leftMenu: 'upgrade',
        icon: 'el-icon-edit-outline'
      },
      {
        path: 'submitted',
        name: 'submitted',
        component: Submitted,
        label: '已提交项目',
        leftMenu: 'submitted',
        icon: 'el-icon-circle-check'
      }
    ]
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    label: '咨询联系',
    leftMenu: 'contact',
    icon: 'el-icon-message'
  }
]

// 没有菜单的路由
const subRouters = [
  {
    path: '/primary',
    name: 'primary',
    component: Primary,
    leftMenu: 'waiting'
  },
  {
    path: '/energy',
    name: 'energy',
    component: Energy,
    leftMenu: 'waiting'
  },
  {
    path: '/technologyList',
    name: 'technologyList',
    component: TechnologyList,
    leftMenu: 'waiting'
  },
  {
    path: '/uploadFile',
    name: 'uploadFile',
    component: UploadFile,
    leftMenu: 'waiting'
  },
  {
    path: '/send',
    name: 'send',
    component: Send,
    leftMenu: 'waiting'
  },
  {
    path: '/update',
    name: 'update',
    component: Update,
    leftMenu: 'submitted'
  },
  {
    path: '/preview',
    name: 'preview',
    component: Preview,
    leftMenu: 'submitted'
  },
  {
    path: '/writeUpgrade',
    name: 'writeUpgrade',
    component: WriteUpgrade,
    leftMenu: 'upgrade'
  }
]

// 没有顶部、侧边模板的路由
const hiddenRouters = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'login',
    component: Login
  }
]

const allRouters = leftRouters.concat(hiddenRouters).concat(subRouters)

const router = window.router = new Router(
  {
    routes: allRouters
  }
)

router.beforeEach((to, from, next) => {
  if (to.name !== 'login') {
    const userInfo = getUserInfo()
    if (!userInfo) {
      router.push('/login')
      return
    }
  }

  const isHiddenContainer = hiddenRouters.some((item) => {
    return item.name === to.name
  })
  // 隐藏顶部和左侧菜单
  if (isHiddenContainer) {
    store.commit('changeIsHiddenContainer', true) // 隐藏
  } else {
    store.commit('changeIsHiddenContainer', false) // 不隐藏
    // 决定leftNav选中哪个
    leftRouters.some(item => {
      if (item.name === to.name) {
        store.commit('changeActive', item.leftMenu)
        return true
      }
    })
  }
  next()
})

export default router
